import { render, staticRenderFns } from "./FabricIndex.vue?vue&type=template&id=47d65038&"
import script from "./FabricIndex.vue?vue&type=script&lang=js&"
export * from "./FabricIndex.vue?vue&type=script&lang=js&"
import style0 from "./FabricIndex.vue?vue&type=style&index=0&id=47d65038&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports